    <button 
      [ngClass]="getButtonClass()" 
      [disabled]="disabled || loading" 
      (mousedown)="pressed = true" 
      (mouseup)="pressed = false"
      (mouseleave)="pressed = false"
      (click)="onClick()">
      
      @if (type === "icon" || type === "iconDanger" || type === "transparentIcon" || type === "primaryIcon") {
        <span class="flex items-center justify-center space-x-2" [ngClass]="{'font-normal': disabled,'font-semibold':!disabled}">
          <i [class]="icon" class="align-middle mr-2 mt-2"></i>
        </span>
      }
      
      @if (type==="loader") {
        @if (loading) {
          <span class="flex items-center space-x-4">
            <svg class="spinner animate-spin" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.9 12C0.402944 12 -0.00351238 12.4035 0.0337288 12.8992C0.188257 14.9559 0.870892 16.9435 2.02236 18.6668C3.34094 20.6402 5.21508 22.1783 7.4078 23.0866C9.60051 23.9948 12.0133 24.2324 14.3411 23.7694C16.6689 23.3064 18.8071 22.1635 20.4853 20.4853C22.1635 18.8071 23.3064 16.6689 23.7694 14.3411C24.2324 12.0133 23.9948 9.60051 23.0866 7.4078C22.1783 5.21509 20.6402 3.34094 18.6668 2.02237C16.9435 0.870893 14.9559 0.188258 12.8992 0.033729C12.4035 -0.00351229 12 0.402944 12 0.9C12 1.39706 12.4037 1.79588 12.8989 1.83968C14.5991 1.99008 16.2396 2.56539 17.6668 3.51901C19.3442 4.6398 20.6516 6.23282 21.4236 8.09663C22.1956 9.96044 22.3976 12.0113 22.004 13.9899C21.6104 15.9685 20.639 17.786 19.2125 19.2125C17.786 20.639 15.9685 21.6104 13.9899 22.004C12.0113 22.3976 9.96043 22.1956 8.09663 21.4236C6.23282 20.6516 4.6398 19.3442 3.51901 17.6668C2.56539 16.2396 1.99008 14.5991 1.83968 12.8989C1.79588 12.4037 1.39706 12 0.9 12Z" fill="currentColor"/>
            </svg>
          </span>
        } @else {
          <span [ngClass]="{'font-normal': disabled,'font-semibold':!disabled}">{{text}}</span>
        }  
      }

      @if (type !== "loader") {
        <span [ngClass]="{'font-normal': disabled,'font-semibold':!disabled}">{{text}}</span>
      }
    </button>